import React from "react";

const ActualExamRehearsal = () => {
  return (
    <div className="bg-white py-6 px-4 text-center shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1),0_4px_6px_-1px_rgba(0,0,0,0.1)] font-outfitRegular mb-1">
      <h2 className="text-xl md:text-2xl">
        IT'S NOT <span className="font-outfitSemiBold">JUST ANOTHER MOCK TEST</span>. IT'S THE{" "}
        <span className="text-primary-900 font-outfitSemiBold">ACTUAL EXAM REHEARSAL</span>
      </h2>
    </div>
  );
};

export default ActualExamRehearsal;
